module.exports = __webpack_public_path__ + "static/media/CO.255eb72a.svg";